import React from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import type { SourceTypeChipProps } from '../types';

/**
 * SourceTypeChip - names where a document came from
 *
 * FAQ entries, pages added by URL and documents pulled from SharePoint or
 * Teams each get their own label and colour; everything a user uploaded
 * stays "custom". Without this, all of them read as "custom" and the table
 * cannot tell an answer from the FAQ apart from an uploaded file.
 */
const LABELS: Record<string, { key: string; color: 'primary' | 'info' | 'secondary' | 'default' }> = {
  sap: { key: 'documents.table.sap', color: 'primary' },
  faq: { key: 'documents.table.faq', color: 'secondary' },
  url: { key: 'documents.table.url', color: 'info' },
  web: { key: 'documents.table.url', color: 'info' },
  sharepoint: { key: 'documents.table.sharepoint', color: 'info' },
  msgraph: { key: 'documents.table.sharepoint', color: 'info' },
};

export const SourceTypeChip: React.FC<SourceTypeChipProps> = ({ sourceType, isSap }) => {
  const { t } = useTranslation();

  const entry = isSap ? LABELS.sap : LABELS[(sourceType ?? '').toLowerCase()];

  return (
    <Chip
      label={entry ? t(entry.key) : t('documents.table.custom')}
      color={entry ? entry.color : 'default'}
      size="small"
      variant={entry && entry.color !== 'primary' ? 'outlined' : 'filled'}
    />
  );
};

SourceTypeChip.displayName = 'SourceTypeChip';
